import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole, logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export interface KillSwitchPayload {
  grid_identifier: string;
  client_id: string;
  agent_mode: boolean;
  autopass_review?: boolean;
  remarks: string;
  user_id: string;
}

export const killSwitch = async (payload: KillSwitchPayload) => {
  try {
    logDataToConsole("Making kill switch API call with payload", payload);

    const token = await getBearerToken();

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.KILL_SWITCH, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      logError(
        new Error(
          `Kill switch API call failed: ${response.status} ${response.statusText}`,
        ),
        errorText,
      );
      return {
        success: false,
        message: `Request failed with status ${response.status}: ${response.statusText}`,
      };
    }

    const responseData = await response.json();
    return {
      success: responseData?.success === true,
      message: responseData?.message,
      data: responseData,
    };
  } catch (error) {
    logError(error as Error, "Error in killSwitch");
    return {
      success: false,
      message:
        error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
